import { useCallback, useEffect, useRef, useState } from "react";

import {
    BRANCH_CHANNEL,
    BRANCH_STORAGE_KEY,
    getBranchId,
    setBranchId,
} from "../branch";

export const useBranchId = (): string => {
    const [branchId, setLocal] = useState<string>(getBranchId);

    useEffect(() => {
        const sync = () => setLocal(getBranchId());

        let channel: BroadcastChannel | null = null;
        try {
            channel = new BroadcastChannel(BRANCH_CHANNEL);
            channel.onmessage = (e: MessageEvent) => {
                if (e.data?.type === "BRANCH_CHANGE") sync();
            };
        } catch {
        }

        const onStorage = (e: StorageEvent) => {
            if (e.key === BRANCH_STORAGE_KEY) sync();
        };
        window.addEventListener("storage", onStorage);

        return () => {
            try {
                channel?.close();
            } catch {
            }
            window.removeEventListener("storage", onStorage);
        };
    }, []);

    return branchId;
};

export const useBranchSync = (tabId: string): void => {
    const loadedWith = useRef<string>(getBranchId());

    useEffect(() => {
        const reloadIfChanged = (next?: string | null) => {
            if (!next || next === loadedWith.current) return;
            window.location.reload();
        };

        let channel: BroadcastChannel | null = null;
        try {
            channel = new BroadcastChannel(BRANCH_CHANNEL);
            channel.onmessage = (e: MessageEvent) => {
                const { type, branchId, senderId } = e.data || {};
                if (type !== "BRANCH_CHANGE" || senderId === tabId) return;
                reloadIfChanged(branchId);
            };
        } catch {
        }

        const onStorage = (e: StorageEvent) => {
            if (e.key === BRANCH_STORAGE_KEY) reloadIfChanged(e.newValue);
        };
        window.addEventListener("storage", onStorage);

        return () => {
            try {
                channel?.close();
            } catch {
            }
            window.removeEventListener("storage", onStorage);
        };
    }, [tabId]);
};

export const useApplyBranch = (tabId: string) =>
    useCallback(
        (id: string) => {
            setBranchId(id, tabId);
            setTimeout(() => window.location.reload(), 50);
        },
        [tabId]
    );
